<template>
  <section class="gridClass my-8">
    <section class="relative">
      <component
        :is="props.titleTag"
        class="text-base lg:text-2xl font-bold text-center"
        :class="props.subTitle || props.desc ? 'mb-5' : 'mb-10 lg:mb-14'"
      >
        {{ props.title ? props.title : "بسته های مرکز تلفن ابری نواتل" }}
      </component>
      <h4 
        v-if="props.subTitle"
        class="text-sm lg:text-base text-blue-500 font-bold text-center mb-10 lg:mb-14"
      >
        {{ props.subTitle }}
      </h4>
      <p v-if="props.desc" class="mb-15 text-center text-body1-semibold text-gray-500">{{ props.desc }}</p>
      <SectionsPricesCloudPbxUsersRange 
        v-if="isShowRangeInput"
        v-model="count" 
        class="mt-5 mb-20"
      />
      <div
        class="grid grid-cols-1 tablet:grid-cols-2 laptop-m:flex gap-14 lg:gap-6 justify-center"
        :class="props.items.length === 2 && 'lg:items-center! lg:justify-center! gap-10!'"
      >
        <div
          class="w-[90%] laptop-m:w-[96%] p-4 custom-shadow relative rounded-xl"
          :class="props.items.length === 2 && 'max-w-80 py-12'"
          v-for="item in props.items"
          :key="item.id"
        >
          <ProductPlan 
            :item="item" 
            :shoppingSrc="props.shoppingSrc" 
            :freeSetupChip="props.freeSetupChip" 
            :priceType="props.priceType" 
          />
        </div>
      </div>
    </section>
    <div
      v-if="!props.hideCompare"
      class="py-6 px-2 mt-8 mb-12 bg-gray-200 flex flex-col lg:flex-row justify-center items-center"
    >
      <span class="me-6 font-bold text-black text-sm">
        در مورد بسته ها نیاز به اطلاعات بیشتر دارید؟
      </span>
      <BaseButton
        @click="isModalShow = true"
        isLean
        size="2xl"
        :text="props.compareText || 'مقایسه بسته ها'"
        color="primary"
      />
    </div>
    <SectionModalCompare
      :isShow="isModalShow"
      @close="isModalShow = false"
      :data="props.compareData"
      :id="props.id"
    />
  </section>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    items: Record<string, any>[],
    title: string,
    subTitle?: string,
    desc?: string,
    fullButton: boolean,
    onlyOnlineBtn: boolean,
    hideCompare: boolean,
    shoppingSrc: string,
    compareData?: object,
    compareText: string,
    submitOrderBtnText: string,
    id: string,
    titleTag: string,
    freeSetupChip?: boolean,
    priceType: 'تومان' | 'هزارتومان',
    isShowRangeInput: boolean,
  }>(),
  {
    titleTag: 'h3',
    shoppingSrc: '/online-shopping/buy/',
    priceType: 'هزارتومان'
  }
);
const isModalShow = ref(false);
const count = defineModel<number>({ default: 0 });
</script>
